// @mui
import Stack from '@mui/material/Stack';
//
import NavList from './nav-list';

// ----------------------------------------------------------------------

export default function NavDesktop({ offsetTop, data }: any) {
  // Filter out "Order Now" and "Subscribe" from desktop nav
  const desktopData = data.filter(
    (link: any) => link.title !== 'Order Now' && link.title !== 'Subscribe'
  );

  return (
    <Stack component="nav" direction="row" spacing={5} sx={{ mr: 2.5, height: 1 }}>
      {desktopData.map((link: any) => (
        <NavList key={link.title} item={link} offsetTop={offsetTop} />
      ))}
    </Stack>
  );
}
